import IEquipment from "models/sql/IEquipment";
import { formatDate } from "./StringUtility";

export const getDemoStatus = (equipment: IEquipment) => {
    // todo: update to use qa, received, shipped, demo, etc
    if (equipment.registrationDate) {
        if (equipment.outOfServiceDate) {
            return "Complete";
        }
        else {
            return "In-Use";
        }
    }
    else if (equipment.repAssignDate) {
        return "Tagged";
    }
    else if (equipment.dealerId) {
        return "Assigned";
    }
};

export const getDemoStatusDate = (equipment: IEquipment) => {
    // todo: update to use qa, received, shipped, demo, etc
    if (equipment.registrationDate) {
        if (equipment.outOfServiceDate) {
            return formatDate(equipment.outOfServiceDate);
        }
        else {
            return formatDate(equipment.registrationDate);
        }
    }
    else {
        if (equipment.repAssignDate) {
            return formatDate(equipment.repAssignDate);
        }
        else if (equipment.dealerId) {
            return formatDate(equipment.created);
        }
    }

    return "N/A";
};

export const getStatus = (equipment: IEquipment) => {
    if (equipment.registrationDate) {
        if (equipment.outOfServiceDate) {
            if (!equipment.score) {
                return "Pending";
            }
            else {
                if (equipment.score == -99) {
                    return "Auto Expired";
                }
            }
        }
        else {
            return "In-Use";
        }
    }
    else if (equipment.repAssignDate) {
        return "Tagged";
    }
    else if (equipment.dealerId) {
        return "Assigned";
    }
};

export const getStatusDate = (equipment: IEquipment) => {
    if (equipment.registrationDate) {
        if (equipment.outOfServiceDate) {
            return formatDate(equipment.outOfServiceDate);
        }
        else {
            return formatDate(equipment.registrationDate);
        }
    }
    else {
        if (equipment.repAssignDate) {
            return formatDate(equipment.repAssignDate);
        }
        else if (equipment.dealerId) {
            return formatDate(equipment.created);
        }
    }

    return "N/A";
};
